var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commoditysearch",staticStyle:{"position":"relative"}},[(!_vm.isShow)?_c('div',{class:{'mask': !_vm.isShow}},[_vm._v("已隐藏")]):_vm._e(),_vm._t("name"),_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-input-wrapper",style:({
        border: `2px solid ${_vm.datas.borderColor || '#e0e0e0'}`,
        backgroundColor: _vm.datas.backgroundColor || '#f5f5f5',
        borderColor: _vm.datas.borderColor || '#e0e0e0',
        borderRadius: `${_vm.datas.moduleStyleType  ==1 ? 30 :10}px`,
      })},[_c('div',{staticStyle:{"display":"flex","width":"100%"}},[_c('i',{staticClass:"iconfont icon-sousuo",staticStyle:{"margin-right":"10px"},style:({ color: _vm.datas.borderColor || '#333' })}),_c('div',{staticStyle:{"width":"100%","display":"flex","align-items":"center"},style:({
            fontFamily: _vm.datas.fontFamily,
            fontSize: `${_vm.datas.fontSize}px`,
            textAlign:
              _vm.datas.textPosition === 0
                ? 'left'
                : _vm.datas.textPosition === 1
                ? 'center'
                : 'right',
          })},[_c('span',{style:({
              color: _vm.datas.textColor,
              fontSize: `${_vm.datas.fontSize}px`,
            })},[_vm._v(_vm._s(_vm.datas.text))])])]),_c('van-button',{staticStyle:{"width":"80px","background-color":"var(--theme-primary)"},style:({
          borderRadius:  `${_vm.datas.moduleStyleType  ==1 ? 30 :10}px`,
        }),attrs:{"type":"info","size":"small"}},[_c('span',{staticStyle:{"padding":"0 10px"},style:({
            fontSize: `${_vm.datas.fontSize}px`,
          })},[_vm._v(" 搜索 ")])])],1)]),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }